// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"selection-items_shadow__RfqDC","link":"selection-items_link__2Ye4x","badge":"selection-items_badge__EbVLE"};